import React, { useState, useRef } from 'react';

const ColorGrading = ({
  before = "/placeholder.svg",
  after = "/placeholder.svg",
  beforeLabel = "Original",
  afterLabel = "Editada"
}) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = () => setIsDragging(true);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };

  const handleTouchMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    setSliderPosition(Math.max(0, Math.min(100, percentage)));
  };

  return (
    <div className="color-grading-comparison">
      <h2 className="color-grading-title">Aplicando Color Grading</h2>
      <div
        ref={containerRef}
        className="color-grading-slider"
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleMouseUp}
      >
        {/* Imagem Original */}
        <div className="color-grading-img original">
          <img src={before} alt="Imagem original" draggable={false} />
          <div className="color-grading-label right">{beforeLabel}</div>
        </div>
        {/* Imagem Editada */}
        <div
          className="color-grading-img edited"
          style={{ clipPath: `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)` }}
        >
          <img src={after} alt="Imagem editada" draggable={false} />
          <div className="color-grading-label left">{afterLabel}</div>
        </div>
        {/* Linha do Slider */}
        <div
          className="color-grading-divider"
          style={{ left: `${sliderPosition}%` }}
        >
          <div
            className="color-grading-handle"
            onMouseDown={handleMouseDown}
            onTouchStart={handleMouseDown}
          >
            <div className="color-grading-bar"></div>
            <div className="color-grading-bar"></div>
          </div>
        </div>
      </div>
      <div className="color-grading-instruction">
        <p>Arraste o slider para comparar antes e depois</p>
      </div>
    </div>
  );
};

export default ColorGrading; 